import Button from 'components/Button';
import Select from 'components/Select';
import styled from 'styled-components';
import tokens from 'tokens';
import { Autocomplete, theme } from '@klover/attain-design-system';
import { Form as FormikForm } from 'formik';
import { TextField } from '@mui/material';

export const Form = styled(FormikForm)`
  display: inline-block;
`;

export const ButtonComponent = styled(Button)``;

export const ButtonSpacing = styled.div`
  display: flex;

  & > * + * {
    margin-left: ${tokens.spacing.sm};
  }
`;

export const ModeledSize = styled.div`
  text-align: left;
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
`;

export const Or = styled.span`
  margin: 0 ${tokens.spacing.sm};
  text-transform: uppercase;
`;

export const OffersColumn = styled.div`
  width: 150px;
`;

export const RawCount = styled.div`
  text-align: right;
  max-width: 72px;
`;

export const AudienceGroup = styled.div`
  padding-left: 10px;
`;

export const AudienceName = styled.div`
  margin-left: 0px;
  font-size: 16px;
  max-width: 550px;
  white-space: normal;
  text-align: start;
`;

export const AudienceID = styled.div`
  max-width: 15px;
`;

export const Type = styled.div`
  font-size: 16px;
  display: flex;
  flex-direction: column;
  text-align: start;
`;

export const AudienceStatus = styled.div`
  display: flex;
  font-size: 16px;
`;

export const LastModified = styled.div`
  font-size: 14px;
  text-align: center;
`;

export const SearchArea = styled.div`
  position: sticky;
  top: 64px;
  z-index: 1;
  background: white;
  padding: 16px 16px 16px 0px;
`;

export const SelectOfferGroup = styled(Select)`
  width: 200px;
`;

export const SelectAutoCompleteGroup = styled(Autocomplete)`
  width: 200px;
  margin-left: 16px;
  display: inline-flex;
  & input {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
`;

export const SelectAutoCompleteGroupOptions = styled.li`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  word-break: break-all;
`;

export const SelectAutoCompleteGroupInput = styled(TextField)({
  '& .MuiInputBase-input': {
    fontSize: `14px`,
  },
});

export const SelectAutoCompleteEmail = styled(Autocomplete)`
  width: 200px;
  margin-left: 16px;
  display: inline-flex;
  & input {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
`;

export const Spinner = styled.div`
  min-height: 100%;
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: 80vh;
`;

export const Wrapper = styled.div`
  ${theme.mixins.card};
  overflow: hidden;
  margin: 2% 0% 0% 0%;
  gap: 10px;
  display: flex;
  flex-direction: column;
`;

export const CardBody = styled.div`
  align-items: center;
  display: flex;
  gap: ${theme.spacing.xxs};
`;
